import React from 'react';
import { css } from 'aphrodite';
import styles from './dashboard-summary-styles';
import { ContentCard, ContentRow, Dropdown, Button, Switch, GreenButton, RedButton, OrangeButton } from '../common';
import Checkbox from '../common/checkbox/checkbox';

const DashboardSummaryView = (props) => (
  <div className={css(styles.root)}>
    <ContentCard title={'Jobs summary'}>
      <ContentRow permissionNeeded={'payment'}>
        Summary of live jobs, map of available drivers, account summary?
      </ContentRow>

      <ContentRow>
        <Dropdown selectedOption={'Example dropdown'}
          options={[{ name: 'Example dropdown' }, { name: 'Foo' }, { name: 'Bar' }]} />
      </ContentRow>

      <ContentRow>
        <div>Button that does something</div>
        <div style={{ flex: 1 }} />
        <Button title={'Set button to loading'} onClick={props.setLoading} loading={props.loading} />
      </ContentRow>

      <ContentRow>
        <div>Green button that does something</div>
        <div style={{ flex: 1 }} />
        <GreenButton title={'Show success Message'} onClick={() => props.showSuccess('Success message!')} />
      </ContentRow>

      <ContentRow>
        <div>Red button that does something</div>
        <div style={{ flex: 1 }} />
        <RedButton title={'Delete'} onClick={() => props.showError('Could not delete item')} />
      </ContentRow>

      <ContentRow>
        <div>Log out</div>
        <div style={{ flex: 1 }} />
        <RedButton title={'Logout'} onClick={props.logout} />
      </ContentRow>

      <ContentRow>
        <div>Expire session</div>
        <div style={{ flex: 1 }} />
        <OrangeButton title={'Expire session'} onClick={props.expireSession} />
      </ContentRow>

      <ContentRow>
        <div>Disabled button</div>
        <div style={{ flex: 1 }} />
        <Button title={'This button is disabled'} disabled={true} />
      </ContentRow>

      <ContentRow>
        <div>Button that is loading / has been triggered</div>
        <div style={{ flex: 1 }} />
        <Button title={'Loading'} loading={true} />
      </ContentRow>

      <ContentRow>
        <div>Checkbox</div>
        <div style={{ flex: 1 }} />
        <Checkbox />
      </ContentRow>

      <ContentRow>
        <div>Switch</div>
        <div style={{ flex: 1 }} />
        <Switch />
      </ContentRow>

    </ContentCard>
  </div>
);

export default DashboardSummaryView;



// WEBPACK FOOTER //
// ./src/components/dashboard-summary/dashboard-summary-view.js